import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, computed, inject, input, output} from '@angular/core';
import {Router} from '@angular/router';
import {DateTime} from 'luxon';

import {InstitutionContextService} from 'libs/data-access/institution/src/lib/services/institution-context.service';
import {FacultyNotification} from 'libs/data-access/notification/src/lib/models/request-response-notification.models';
import {generateHumanizedDate} from 'libs/shared/util/src/lib/_helpers/date-helper';

@Component({
    imports: [CommonModule],
    selector: 'lib-learner-bulk-import-complete',
    templateUrl: './learner-bulk-import-complete.component.html',
    styleUrl: './learner-bulk-import-complete.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LearnerBulkImportCompleteComponent {
    router = inject(Router);
    condensedView = input(false);

    notification = input<FacultyNotification>();
    notificationRead = output<void>();

    learnerText = inject(InstitutionContextService).contextLearnerText;
    learnerTextSingular = computed(() => this.learnerText().SingularForm.toLowerCase());
    learnerTextPlural = computed(() => this.learnerText().PluralForm.toLowerCase());

    completedLearners = computed(() =>
        this.notification().InstitutionBulkEnrollmentNotification?.Completed > 1
            ? this.learnerTextPlural()
            : this.learnerTextSingular()
    );
    failedLearners = computed(() =>
        this.notification().InstitutionBulkEnrollmentNotification?.Failed > 1
            ? this.learnerTextPlural()
            : this.learnerTextSingular()
    );
    allLearners = computed(() =>
        this.notification().InstitutionBulkEnrollmentNotification?.Failed +
            this.notification().InstitutionBulkEnrollmentNotification?.Completed >
        1
            ? this.learnerTextPlural()
            : this.learnerTextSingular()
    );

    date = computed(() => {
        return generateHumanizedDate(this.notification().AvailableDate ?? DateTime.now());
    });

    viewSubscription(): void {
        this.notificationRead.emit();
        this.router.navigateByUrl(
            // eslint-disable-next-line max-len
            `/manage/subscriptions/view/${this.notification().InstitutionBulkEnrollmentNotification?.InstitutionSubscriptionId}`
        );
    }

    viewImportHistory(): void {
        this.notificationRead.emit();
        this.router.navigateByUrl(
            // eslint-disable-next-line max-len
            `/manage/subscriptions/import/history/${this.notification().InstitutionBulkEnrollmentNotification?.BulkEnrollmentId}`
        );
    }
}
